
import { HttpAttachmentFileList, HttpDelAttachmentFile } from "@/service/ucadm";
import TableList from "@components/templates/tablelist";
import mixin from '../mixin'
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
        }
    },
    methods: {
        ajaxRequest: HttpAttachmentFileList,
        handleOperates(params, type) {
            switch (type) {
                case 'del':
                    this.operate = {
                        show: false,
                        alert: 'error',
                        params: { id: params },
                        title: '删除',
                        ajaxRequest: HttpDelAttachmentFile,
                    }
                    break
                case "download":
                    this.handleWebfs(params, {}, {  executor: 'download', type: "url" });
                    break;
            }
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: '查看',
                show: true,
                to: {
                    name: 'attachmentfileUpdate',
                    query: { id },
                    params: {
                        type: 'query'
                    }
                }
            }, {
                label: '删除',
                show: true,
                params: id,
                operate: 'del'
            }
            ]
        },
    },
    computed: {
        ToolsData() {
            return [
                {
                    label: '添加',
                    theme: 'primary',
                    to: {
                        name: 'attachmentfileUpdate',
                        params: { type: 'add' },
                    }
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: 'ID',
                    key: 'EQ_id',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: '环境类型',
                    key: 'EQ_envType',
                    tag: 'vSelect',
                    show: true,
                    options: this.getEnvTypes,
                },
                {
                    label: '模块',
                    key: 'EQ_modelId',
                    tag: 'vSelect',
                    show: true,
                    options: this.getAttachmentModels,
                },
                {
                    label: '类型',
                    key: 'EQ_typeId',
                    tag: 'vSelect',
                    more:true,
                    options: this.getAttachmentTypes,
                },
                {
                    label: '单据标识',
                    key: 'EQ_srcLabel',
                    tag: 'vInput',
                    more:true,
                },
            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    width: 110,
                    render: this.getOperateNodes
                },
                {
                    title: 'ID',
                    key: 'id',
                },
               
                {
                    title: '标题',
                    key: 'title',
                },
                {
                    title: '文件名',
                    key: 'filename',
                    render: (h, { row }) => {
                        return <a class="color-link" onClick={this.handleOperates.bind(this, row.url, 'download')}>{row.filename}</a>
                    },
                },
                // {
                //     title: '文件大小',
                //     key: 'fileSize',
                // },
                {
                    title: '单据标识',
                    key: 'srcLabel',
                },
                {
                    title: '环境类型',
                    key: 'envType',
                    render: (h, { row }) => this.findRenderLabel(this.getEnvTypes, row.envType),
                },
                {
                    title: '模块',
                    key: 'modelId',
                    render: (h, { row }) => this.findRenderLabel(this.getAttachmentModels, row.modelId),
                },
                {
                    title: '类型',
                    key: 'typeId',
                    render: (h, { row }) => this.findRenderLabel(this.getAttachmentTypes, row.typeId),
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                }]
        },
    },
}




